import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Customers from "@/pages/Customers";
import CustomerDetail from "@/pages/CustomerDetail";
import Products from "@/pages/Products";
import Quotes from "@/pages/Quotes";
import QuoteEditor from "@/pages/QuoteEditor";
import QuoteDetail from "@/pages/QuoteDetail";
import Staff from "@/pages/Staff";
import Logs from "@/pages/Logs";
import Settings from "@/pages/Settings";

function Protected({ children, adminOnly, requirePerm }) {
  return (
    <ProtectedRoute adminOnly={adminOnly} requirePerm={requirePerm}>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/musteriler" element={<Protected><Customers /></Protected>} />
          <Route path="/musteriler/:id" element={<Protected><CustomerDetail /></Protected>} />
          <Route path="/urunler" element={<Protected><Products /></Protected>} />
          <Route path="/teklifler" element={<Protected><Quotes /></Protected>} />
          <Route path="/teklifler/yeni" element={<Protected><QuoteEditor /></Protected>} />
          <Route path="/teklifler/:id/duzenle" element={<Protected><QuoteEditor /></Protected>} />
          <Route path="/teklifler/:id" element={<Protected><QuoteDetail /></Protected>} />
          <Route path="/personel" element={<Protected requirePerm="view_staff"><Staff /></Protected>} />
          <Route path="/loglar" element={<Protected requirePerm="view_logs"><Logs /></Protected>} />
          <Route path="/ayarlar" element={<Protected requirePerm="view_settings"><Settings /></Protected>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
